import React from "react";
import { Grid, Typography, Container } from "@mui/material";
import { motion } from "framer-motion";
import AnalyticsInsightsImg from "../../../../Svg/newAnalytics.svg";

const AnalyticsInsights = () => {
  return (
    <Container maxWidth="lg">
    <Grid
      container
      item
      xs={12}
      spacing={4}
      alignItems="center"
      justifyContent="center"
      flexDirection={{ xs: "column-reverse", md: "row-reverse" }}
      component={motion.div}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      sx={styles.featureRow}
    >
      <Grid
        item
        xs={12}
        md={4}
        sx={{ textAlign: "center", position: "relative" }}
      >
        <motion.img
          src={AnalyticsInsightsImg}
          alt="Analytics & Insights"
          style={{ maxWidth: "100%", cursor: "pointer" }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          transition={{ duration: 0.3 }}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={4}
        sx={{ textAlign: { xs: "center", md: "left" } }}
        component={motion.div}
                whileHover={{ scale: 1.02 }}
                transition={{ duration: 0.3 }}
      >
        <Typography
          variant="h6"
          fontWeight={700}
          gutterBottom
          component={motion.div}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          viewport={{ once: true }}
        >
          Analytics & Insights
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            mb: 2,
            textAlign: { xs: "center", md: "justify" },
            hyphens: "auto",
          }}
          component={motion.div}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.5 }}
          viewport={{ once: true }}
        >
          Gain real-time data and valuable insights to make informed decisions,
          track performance, and optimize your event for success.
        </Typography>
      </Grid>
    </Grid>
    </Container>
  );
};

export default AnalyticsInsights;

const styles = {
  title: {
    fontWeight: 700,
    // fontSize: { xs: "2rem", md: "2.5rem" },
    fontSize: { xs: 24, sm: 32, md: 40 },
    mb: 3,
  },
  featureRow: {
    "&:hover": {
      transform: "translateY(-5px)",
      transition: "all 0.3s ease",
    },
  },
};
